import {mapFilters} from "@/utils/helpers";


export const actions = {
  async fetchOutgoingConsignments({commit, dispatch}, {filters, pagingInfo}) {
    let outgoingConsignments = [];
    try{
      let filter = mapFilters(filters,pagingInfo.pageNo, pagingInfo.pageSize, pagingInfo.sortBy, pagingInfo.sortAsc);
      let result = await this.$axios.$get(`webpos/outgoing-consignments?${new URLSearchParams(filter).toString()}`)
      if (result && !result.hasErrors) {
        outgoingConsignments = result;
      }
      else{
        this.$toast.error('Error while getting outgoing consignments');
      }
    }
    catch(e){
      this.$toast.error('Error while getting outgoing consignments');
    }
    return outgoingConsignments;
  },

  async fetchOutgoingConsignmentImages({}, consignmentID){
    let images = [];
    try{
      let result = await this.$axios.$get(`webpos/outgoing-consignments/${consignmentID}/images`)
      if (result && result.value && !result.apiMessages.hasErrors ) {
        images = result.value;
      }
      else{
        this.$toast.error('Error while getting outgoing consignment images');
      }
    }
    catch(e){
      this.$toast.error('Error while getting outgoing consignment images');
    }
    return images
  },

  async fetchOutgoingConsignmentItems({}, consignmentID){
    let consignmentItems = [];
    try{
      const result = await this.$axios.get( `/webpos/outgoing-consignments/${consignmentID}/items`);

      if(result?.data?.apiMessages.hasErrors){
        this.$toast.error('Error while getting outgoing consignment items')
      }
      else if(result.data?.value?.length) {
        consignmentItems = result.data.value;
      }
    }
    catch(e){
      this.$toast.error('Error while getting outgoing consignment items')
    }
    return consignmentItems;
  },

  async createOutgoingConsignment({}, consignmentData){
    let actionIsSuccessful = false
    try{
      let result = await this.$axios.$post(`webpos/outgoing-consignments`, consignmentData)

      if (result && result.apiMessages.hasErrors && result.apiMessages.serverErrors.length > 0) {
        this.$toast.error(result.apiMessages.serverErrors[0]);
      }
      else {
        actionIsSuccessful = true;
        this.$toast.success("Outgoing consignment created successfully")
      }
    }
    catch(e){
      this.$toast.error('Error while creating outgoing consignment');
    }
    return actionIsSuccessful;
  },

  async deleteOutgoingConsignmentById({ commit }, { id }) {
    try {
      await this.$axios.$delete(`/webpos/outgoing-consignments/${id}`);
      this.$toast.success(`Outgoing consignment deleted successfully.`);
      return true;
    } catch (e) {
      this.$toast.error('Error while deleting outgoing consignment!');
      return false;
    }
  },

  async getOutgoingConsignmentByID({}, consignmentID){
    let oc = {};
    try{
      let result = await this.$axios.$get(`webpos/outgoing-consignments/${consignmentID}`)
      if (result && result.value && !result.apiMessages.hasErrors ) {
        oc = result.value;
      }
      else{
        this.$toast.error('Error while getting outgoing consignment');
      }
    }
    catch(e){
      this.$toast.error('Error while getting outgoing consignment');
    }
    return oc
  },

  async deleteOutgoingConsignmentItem({ commit }, { consignmentID, itemID }) {
    try {
      await this.$axios.$delete(`/webpos/outgoing-consignments/${consignmentID}/items/${itemID}`);
      this.$toast.success(`Outgoing consignment item deleted successfully.`);
      return true;
    }
    catch (e) {
      this.$toast.error('Error while deleting item outgoing consignment!');
      return false;
    }
  },

  async insertOutgoingConsignmentItem({ commit }, { outgoingConsignmentID, item }) {
    try {
      await this.$axios.post(`/webpos/outgoing-consignments/${outgoingConsignmentID}/items`, item);

      this.$toast.success(`Order item inserted successfully`);
      return true;
    }
    catch (e) {
      this.$toast.error('Error while inserting order item');
      return false;
    }
  },

}



